module.exports = __webpack_public_path__ + "img/tablet-neck-10_18x792.b0aaf7b1.png";